import { get, post, patch, del } from "../common/apiClient";

export function fetchMistakeNotes({ page = 1, limit = 20, topic, errorType, mastered } = {}) {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("limit", String(limit));
    if (topic && topic !== "all") params.append("topic", topic);
    if (errorType && errorType !== "all") params.append("errorType", errorType);
    if (mastered !== undefined && mastered !== null && mastered !== "all") {
        params.append("mastered", String(mastered));
    }
    return get(`/mistakes?${params.toString()}`);
}

export function fetchMistakeNoteById(id) {
    return get(`/mistakes/${encodeURIComponent(id)}`);
}

export function fetchMistakeStats() {
    return get("/mistakes/stats");
}

export function createMistakeNote(data) {
    return post("/mistakes", data);
}

export function updateMistakeNote(id, data) {
    return patch(`/mistakes/${encodeURIComponent(id)}`, data);
}

export function deleteMistakeNote(id) {
    return del(`/mistakes/${encodeURIComponent(id)}`);
}
